/* eslint no-unused-vars: 1 */

/**
 * the main controller there are only helper variables no view control logic the views control the views
 */
(function() {
    'use strict';
    angular.module('porting').controller('portingCtrl', portingCtrl);
    portingCtrl.$inject = [ '$rootScope', '$scope', '$location', '$http', '$injector', '$state', '$stateParams', 'mnpFormProvider', 'mnpNbaProvider', 'providerListService', '$filter', '$window', 'trackingSrv'
    ];
    function portingCtrl($rootScope, $scope, $location, $http, $injector, $state, $stateParams, mnpFormProvider, mnpNbaProvider, providerListService, $filter, $window, trackingSrv) {

        var vm = this;


        vm.$onInit = function () {
            if ('undefined' === typeof $rootScope.thirdPortingCheck){
                vm.thirdPortingCheck = null;
            } else {
                vm.thirdPortingCheck = $rootScope.thirdPortingCheck;
            }



            vm.data = $stateParams.data;
            vm.authenticated = false;
            vm.isPortingPossible = false;
            vm.portingNotPossibleReason = '';
            $rootScope.loading = true;





            vm.config = $injector.get('config');

            vm.partialsBaseUrl = vm.config.partialsBaseUrl;
            vm.userData = window.portingUser || null;

            // store nba promise for later access
            var nbaCall = mnpNbaProvider.checkSession();
            nbaCall.then(function() {
                vm.authenticated = true;
                $rootScope.loading = false;

                if (window.portingUser) {
                    // catch not portable MSISDNs wich can't be catched by deny of login
                    vm.userData = window.portingUser;
                    if ('data' === vm.userData.currentTariffType) {
                        vm.portingNotPossibleReason = 'data';
                        vm.isPortingPossible = false;
                        trackingSrv.trackError('', trackingSrv.E_TYPE_NOTIFICATION, 'porting for data tariff not available', $state.current.url);
                    } else {
                        vm.portingNotPossibleReason = '';
                        vm.isPortingPossible = true;
                    }
                }
            });


            /**
             * set from ref
             */
            vm.setFormRef = function (formRef){
                vm.form = formRef;
            };

            /**
             * to call from views while entering form data to keep the session open or abort if session is closed
             */
            vm.checkSession = function() {
                return mnpNbaProvider.checkSession();
            };

            vm.formUsable = false;
            vm.myEqual = function(a, b) {
                return angular.equals(a, b);
            };

            /** porperties for number PORTING CHECK */
            // of type: {'text':string, 'showStatusButton': bool}
            vm.portingOrderNotification = null;

            // bool value for the second check
            vm.numberToBePortedHasBeenChecked = false;

            /** to be removed */
            vm.setting = {
                edit: false
            };
            vm.linkTitle = 'Zur&uuml;ck';
            vm.emailNotEqualError = vm.config.formErrors.emailNotEqual;
            vm.portingAsap = false;
            vm.portingAsapOnly = false;
            vm.portingAtEnd = false;
            vm.portingNotinTime = true;
            vm.canceltolate = false;
            vm.canceltoearly = false;
            vm.cancelExecuted = false;
            vm.alreadyCanceled = false;
            vm.sectionTwoValid = false;

            vm.isinvalidDate = false;
            vm.isinvalidBirthdate = false;
            vm.isinvalidMSISDN = false;
            vm.date = new Date();
            vm.actualDate = new Date();
            vm.providerSelect = null;

            var providerList = providerListService.providerListGet();
            vm.providerList = providerList;
            providerList.sort(function(a, b) {
                if (a.rank < b.rank) {
                    return -1;
                } else if (a.rank > b.rank) {
                    return 1;
                } else {
                    if (a.displayname.toLowerCase() < b.displayname.toLowerCase()) {
                        return -1;
                    } else if (a.displayname.toLowerCase() > b.displayname.toLowerCase()) {
                        return 1;
                    }
                }
                return 0;
            });
            // bind to view when sorting completed, otherwise error in rendering process!!!
            vm.sortedProviderList = providerList;

            /** in between form to mapped */
            vm.data = {
                soho: false,
                postpaid: false,
                contractCanceled: false,
                providerAlreadyInformed: false,
                cancelationdate: '',
                earliestDateAfterCancel: '',
                earliestdate: new Date(new Date() - (90 * 86400000)),
                latestdate: vm.date.setTime(vm.date.getTime() + (123 * 86400000)),
                fastTrackdate: new Date(new Date().getTime() + (10 * 86400000)),
                contractType: '',
                companyName: '',
                customerId: '',
                name: '',
                surname: '',
                birthdate: '',
                ndc: '',
                msisdn: '',
                ndc1: '',
                msisdn1: '',
                provider: '',
                providerDisplayName: '',
                providerId: '',
                email: '',
                email1: '',
                assure0: false,
                assure1: false
            };

            if ('executeForm' === $state.current.name) {
                vm.data = $stateParams.data;
            }
            vm.portingCart = {};
            vm.stepper = {
                actualStep: '',
                items: [],
                readyItems: []
            };

            vm.changeProviderSelection = function() {
                var selectedProvider = $('#provider option:selected');
                vm.data.providerDisplayName = selectedProvider.html();
                vm.data.providerId = selectedProvider.attr('data-provider-id');
            };

            vm.hideError = function(field) {
                $('.' + field).hide();
                $('.' + field).closest('input').trigger('focus');
            };

            vm.providerPrepaidOnly = function(item) {
                return (!item.onlyprepaid);
            };

            vm.findStepperItems = function() {
                $('stepper-item').each(function(i, o) {
                    vm.stepper.items.push($(o).attr('id'));
                });
            };

            /** step forward */
            vm.stepperGoNextStep = function() {

                // 2. PORTING CHECK
                if ('stepper-customer' === vm.stepper.actualStep && !vm.numberToBePortedHasBeenChecked){
                    var numberData = {'toBePortedMSISDN': vm.data.ndc + vm.data.msisdn };
                    mnpFormProvider.checkIfPortingOrderExistsForNumberToBePorted(vm.config.apiURLs.PORTINGORDEREXISTS, numberData).then(
                        function (result){

                            $rootScope.loading = false;

                            if (200 === result.status){
                                var responseCode = result.data.responseCode;

                                if ('undefined' === typeof responseCode){
                                    // contiue anyway for now
                                    vm.numberToBePortedHasBeenChecked = true;
                                    vm.portingOrderNotification = null;
                                    vm.stepperGoNextStep();
                                } else {
                                    responseCode = responseCode.substring(responseCode.length - 5);

                                    if ('200.0' === responseCode){
                                        // continue
                                        vm.numberToBePortedHasBeenChecked = true;
                                        vm.portingOrderNotification = null;
                                        vm.stepperGoNextStep();
                                    } else {
                                        vm.portingOrderNotification = vm.getPortingOrderError(responseCode);
                                        // also clear the number repeat number field
                                        vm.data.msisdn1 = '';
                                        vm.data.ndc1 = '';

                                        var myForm = vm.form;
                                        myForm.msisdn1.$setPristine();
                                        myForm.msisdn1.$setUntouched();
                                        myForm.msisdn1.$dirty = false;

                                        myForm.portingnumber1.$setPristine();
                                        myForm.portingnumber1.$setUntouched();
                                        myForm.portingnumber1.$dirty = false;

                                    }
                                }
                            } else {
                                vm.portingOrderNotification = vm.getPortingOrderError();
                            }
                        },
                        function (error){
                            $rootScope.loading = false;
                            vm.portingOrderNotification = vm.getPortingOrderError();
                        }
                    );
                    $rootScope.loading = true;
                    return;
                }
                vm.numberToBePortedHasBeenChecked = false;
                // end porting check

                $('#' + vm.stepper.actualStep).removeClass('tg-active').addClass('tg-finish');
                $('#' + vm.stepper.actualStep + ' div.change').removeClass('displayNone');
                $('#' + vm.stepper.actualStep + ' div.tg-item').addClass('disabled');
                $('#' + vm.stepper.actualStep + ' .step-number-digit').addClass('displayNone');
                $('#' + vm.stepper.actualStep + ' svg.icon-list-tick-sml').attr('class', 'icon-list-tick-sml i-sml');
                $('#' + vm.stepper.actualStep + ' div.tg-body').removeClass('tg-display');
                if (-1 === $.inArray(vm.stepper.actualStep, vm.stepper.readyItems)) {
                    vm.stepper.readyItems.push(vm.stepper.actualStep);
                }

                var siteStructure = trackingSrv.getSiteStructure();
                var stepNumber = parseInt($('#' + vm.stepper.actualStep + ' .step-number-digit').html().trim());
                var stepName = $('#' + vm.stepper.actualStep + ' .text-wrap .clearfix').html().trim();
                var status = (1 === stepNumber) ? ['start'] : ['step-done'];
                var formdata = {};
                trackingSrv.trackForm('Rufnummern-Mitnahme', stepNumber, stepName, status, formdata, siteStructure);

                vm.stepper.actualStep = vm.stepper.items[vm.stepper.readyItems.length];
                $('#' + vm.stepper.actualStep).addClass('tg-active').removeClass('tg-finish');
                $('#' + vm.stepper.actualStep + ' div.change').addClass('displayNone');
                $('#' + vm.stepper.actualStep + ' .step-number-digit').removeClass('displayNone');
                $('#' + vm.stepper.actualStep + ' svg.icon-list-tick-sml').attr('class', 'icon-list-tick-sml i-sml displayNone');
                $('#' + vm.stepper.actualStep + ' div.tg-body').addClass('tg-display');
                $('#' + vm.stepper.actualStep + ' div.tg-item').removeClass('disabled');
                $window.scrollTo(0, 200);

                vm.checkSession();
            };

            /** ändern click */
            vm.editStep = function(id) {
                /*
                 * just keep session open so check async no use of .then() needed here
                 */
                vm.checkSession();

                if ('stepper-1' === id) {
                    vm.stepper.readyItems = [];
                }
                vm.data.assure0 = false;
                vm.data.assure1 = false;
                $('#' + vm.stepper.actualStep + ' div.tg-item').addClass('disabled');
                $('#' + vm.stepper.actualStep).removeClass('tg-active').removeClass('tg-finish');
                $('#' + vm.stepper.actualStep + ' div.tg-body').removeClass('tg-display');
                $('#' + id).addClass('tg-active').removeClass('tg-finish');
                $('#' + id + ' div.change').addClass('displayNone');
                $('#' + id + ' .step-number-digit').removeClass('displayNone');
                $('#' + id + ' svg.icon-list-tick-sml').attr('class', 'icon-list-tick-sml i-sml displayNone');
                $('#' + id + ' div.tg-body').addClass('tg-display');
                $('#' + id + ' div.tg-item').removeClass('disabled');
                vm.stepper.actualStep = id;

                var siteStructure = trackingSrv.getSiteStructure();
                var stepNumber = parseInt($('#' + vm.stepper.actualStep + ' .step-number-digit').html().trim());
                var stepName = $('#' + vm.stepper.actualStep + ' .text-wrap .clearfix').html().trim();
                trackingSrv.trackForm('Rufnummern-Mitnahme', stepNumber, stepName, ['edit'], {}, siteStructure);

            };

            /** add zero left */
            vm.padLeft = function(val) {
                if (10 > parseInt(val)) {
                    return '0' + val;
                }
                return val;
            };

            /** date validation switching the variables */
            vm.checkCanceldate = function(val) {
                var temp = angular.isDefined(vm.data.cancelationdate) ? vm.data.cancelationdate.split('.') : [];
                if (3 === temp.length && 4 === temp[2].length) {
                    var tt = new Date(temp[2], parseInt(temp[1]) - 1, temp[0], 12, 0, 0).toLocaleDateString('de-DE').split('T')[0];
                    var tp = tt.split('.');
                    var lD = new Date(temp[2], parseInt(temp[1]) - 1, temp[0], 12, 0, 0);
                    tp[0] = vm.padLeft(tp[0]);
                    tp[1] = vm.padLeft(tp[1]);
                    tt = tp.join('.');

                    // use localeCompare to compare datestrings due to IE11 DEFECT
                    vm.isinvalidDate = (isNaN(temp[0]) || isNaN(temp[1]) || isNaN(temp[2]) || (0 !== vm.data.cancelationdate.localeCompare(tt, 'de')));
                    if (!vm.isinvalidDate) {
                        vm.data.earliestDateAfterCancel = lD.setTime(lD.getTime() - (123 * 86400000));
                        vm.cancelExecuted = (new Date(temp[2], parseInt(temp[1]) - 1, temp[0], 12, 0, 0) <= vm.actualDate);
                        vm.portingAsapOnly = ((new Date(temp[2], parseInt(temp[1]) - 1, temp[0], 12, 0, 0) >= vm.data.earliestdate) && (new Date(temp[2], parseInt(temp[1]) - 1, temp[0], 0, 0, 0) <= vm.data.fastTrackdate));
                        vm.canceltolate = (new Date(temp[2], parseInt(temp[1]) - 1, temp[0], 12, 0, 0) >= vm.data.latestdate);
                        vm.canceltoearly = (new Date(temp[2], parseInt(temp[1]) - 1, temp[0], 12, 0, 0) <= vm.data.earliestdate);
                        vm.portingNotinTime = ((vm.canceltolate && vm.canceltoearly));
                    } else {
                        vm.canceltolate = false;
                        vm.canceltoearly = false;
                        vm.portingAsapOnly = false;
                        vm.cancelExecuted = false;
                    }
                    vm.sectionTwoValid = false;
                    vm.portingNotinTime = ((vm.canceltolate && vm.canceltoearly));
                } else {
                    vm.isinvalidDate = true;
                }
            };

            vm.checkMSISDN = function() {
                if (vm.data.msisdn && vm.data.ndc){
                    mnpFormProvider.mobileNumberCheck(vm.data.ndc, vm.data.msisdn)
                        .done(function(){
                            vm.isinvalidMSISDN = false;
                        })
                        .fail(function(){
                            vm.isinvalidMSISDN = true;
                        });
                }
            };

            vm.checkBirthDate = function() {
                var birthdateParts = vm.data.birthdate.split('.');
                var valid = false;

                if ( 3 === birthdateParts.length ){
                    var dayInserted = parseInt(birthdateParts[0]);
                    var monthInserted = parseInt(birthdateParts[1]);
                    var yearInserted = parseInt(birthdateParts[2]);

                    if ( 0 !== dayInserted && 0 !== monthInserted && 0 !== yearInserted ) {
                        var d = new Date(yearInserted, (monthInserted - 1), dayInserted);
                        if (d){
                            var day = d.getDate();
                            var month = d.getMonth() + 1;
                            var year = d.getFullYear();
                            valid = (month === monthInserted && day === dayInserted && year === yearInserted);
                        }
                    }
                }

                vm.isinvalidBirthdate = !valid;
            };

            /** display the button for provider fon */
            vm.showProviderLink = function(key) {
                if (isNaN(parseInt(key))) {
                    vm.providerIndex = -1;
                    vm.validProvider = false;
                } else {
                    var providerNames = providerListService.providerListGet();
                    vm.providerIndex = parseInt(key);
                    vm.validProvider = (providerNames[key].number && 'nv' !== providerNames[key].number.toLowerCase() && 2 < providerNames[key].number.length);
                }
            };

            /** transform the data from the view to Form for ishop */
            vm.mapDataAndCheck = function() {
                vm.portingCart = {};
                vm.portingCart.formData = window.portingForm.formData;

                vm.portingCart.formData.PORTINGREQUEST.portingrequest_bisherigerProvider.val = vm.data.provider;
                vm.portingCart.formData.PORTINGREQUEST.portingrequest_bisherigerProviderID.val = vm.data.providerId;
                if ('privat' === vm.data.contractType) {
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_dob_day.val = parseInt(vm.data.birthdate.split('.')[0]);
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_dob_month.val = parseInt(vm.data.birthdate.split('.')[1]);
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_dob_year.val = parseInt(vm.data.birthdate.split('.')[2]);
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_firstname.val = vm.data.name;
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_lastname.val = vm.data.surname;
                    // vm.portingCart.formData.PORTINGREQUEST.portingrequest_kundennummer.val
                    // = '123';
                } else {
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_firmenname.val = vm.data.companyName;
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_kundennummer.val = vm.data.customerId;
                }
                if ('' !== vm.data.cancelationdate) {
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_vertragsende_day.val = parseInt(vm.data.cancelationdate.split('.')[0]);
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_vertragsende_month.val = parseInt(vm.data.cancelationdate.split('.')[1]);
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_vertragsende_year.val = parseInt(vm.data.cancelationdate.split('.')[2]);
                }
                vm.portingCart.formData.PORTINGREQUEST.portingrequest_kundentyp.val = ('soho' === vm.data.contractType) ? 2 : 1;
                vm.portingCart.formData.PORTINGREQUEST.portingrequest_rufnummer_msisdn.val = vm.data.msisdn;
                vm.portingCart.formData.PORTINGREQUEST.portingrequest_rufnummer_ndc.val = vm.data.ndc;
                vm.portingCart.formData.PORTINGREQUEST.portingrequest_usecase.val = (vm.portingAsap) ? 'Schnellstmoeglich' : 'VertragsEnde';
                vm.portingCart.formData.PORTINGREQUEST.portingrequest_kartentyp.val = 'Normal';
                vm.portingCart.formData.PORTINGREQUEST.portingrequest_ultracard.val = 0;
                if (!vm.portingCart.formData.PORTINGREQUEST.portingrequest_kontaktemail) { // eslint-disable-line camelcase
                    vm.portingCart.formData.PORTINGREQUEST.portingrequest_kontaktemail = { // eslint-disable-line camelcase
                        val: '',
                        valiURI: '',
                        min: 6,
                        max: 240,
                        mand: 'Y',
                        type: 'string',
                        ro: 'N'
                    };
                }
                vm.portingCart.formData.PORTINGREQUEST.portingrequest_kontaktemail.val = vm.data.email;

                return true;
            };

            /** send the form and afterwards do orderPost */
            vm.updateScopeAndSubmit = function() {
                $rootScope.loading = true;
                var siteStructure = trackingSrv.getSiteStructure();
                trackingSrv.trackForm('Rufnummern-Mitnahme', 5, 'Auftrag abschicken', ['finished'], {}, siteStructure);

                if (vm.mapDataAndCheck()) {
                    mnpFormProvider.portingRequestCheckoutPut(vm.config.apiURLs.CHECKOUT, vm.portingCart).then(vm.orderPost, throwError);
                } else {
                    $rootScope.loading = false;
                }
            };

            vm.orderPost = function(response) {

                var orderData = {
                    'b_id': vm.config.shopCredentials.bId,
                    'shop_id': vm.config.shopCredentials.shopId
                };
                mnpFormProvider.portingRequestOrderPost(vm.config.apiURLs.ORDER, orderData).then(
                function (success){

                    vm.data.order = response.data;
                    vm.data.portingAsap = vm.portingAsap; // pass through to confirmation page

                    $state.go('executeForm', {
                        data: vm.data
                    });
                    vm.scrollTop();
                    $rootScope.loading = false;
                    vm.portingOrderNotification = null;
                },
                function (error){
                    // go to initial state
                    // 3. PORTING CHECK
                    var responseCode = error.data.responseCode;

                    if ('undefined' === typeof responseCode){
                        $rootScope.thirdPortingCheck = vm.getPortingOrderError();
                    } else {
                        $rootScope.thirdPortingCheck = vm.getPortingOrderError(responseCode.substring(responseCode.length - 5));
                    }

                    $state.go('home');
                    vm.scrollTop();

                    vm.throwError(error);

                });
            };

            vm.scrollTop = function() {
                $window.scrollTo(0, 0);
            };

            vm.initPortingRequestBasket = function() {
                // wait until nba call response
                nbaCall.then(function() {
                    if (!vm.userData) {
                        $state.go('home');
                    } else {
                        // first check if porting order already exists
                        // 1. PORTING CHECK
                        $rootScope.loading = true;
                        vm.checkIfPortingOrderExistsForPreliminaryNumber();
                    }
                });

            };


            /*
              * 1. PORTING CHECK
             */
            vm.checkIfPortingOrderExistsForPreliminaryNumber = function (){
                mnpFormProvider.checkIfPortingOrderExistsForPreliminaryNumber(vm.config.apiURLs.PORTINGORDEREXISTS).then(
                function (result){
                    $rootScope.loading = false;

                    if (200 === result.status){
                        var responseCode = result.data.responseCode;

                        if ('undefined' === typeof responseCode){
                            // continiue anyway for now
                            vm.portingOrderNotification = null;
                            mnpFormProvider.portingRequestBasketPut(vm.config.apiURLs.BASKET, 'msisdn', vm.userData.MSISDN.replace('GSM', '0')).then(continueFlow, throwError);
                        } else {
                            responseCode = responseCode.substring(responseCode.length - 5);
                            if ('200.0' === responseCode){
                                // continiue
                                vm.portingOrderNotification = null;
                                mnpFormProvider.portingRequestBasketPut(vm.config.apiURLs.BASKET, 'msisdn', vm.userData.MSISDN.replace('GSM', '0')).then(continueFlow, throwError);
                            } else {
                                vm.portingOrderNotification = vm.getPortingOrderError(responseCode);
                            }
                        }
                    } else {
                        vm.portingOrderNotification = vm.getPortingOrderError();
                    }
                },
                function (error){
                    $rootScope.loading = false;
                    vm.portingOrderNotification = vm.getPortingOrderError();
                });
            };


            /*
            * helper function to get the porting notification
            * @param {string} serverResponseCode - the status code
            * @return {{ text: string, showStatusButton: boolean }} - an object containing the error message and a flag wether the button should be displayed
            */
            vm.getPortingOrderError = function(serverResponseCode) {


                if ('undefined' === typeof serverResponseCode){
                    return {'text': 'Ups! Die Technik hakt grad. Sorry, unser Fehler. Deine Rufnummern-Mitnahme können wir im Moment nicht bearbeiten. Bitte versuch\'s später nochmal. Danke für Dein Verständnis!', 'showStatusButton': false};

                } else {
                    switch (serverResponseCode){
                    case '200.1':
                        return {'text': 'Für diese Nummer ist die Rufnummern-Mitnahme schon beauftragt. Den Status Ihres Auftrags sehen Sie jederzeit online.', 'showStatusButton': true};

                    case '200.2':
                        return {'text': 'Sind sie sicher, dass Sie diese Rufnummer zu uns mitnehmen wollen? Haben Sie uns vielleicht schon einen Auftrag für diese Nummer geschickt? Bitte kontrollieren Sie die eingetippte Rufnummer nochmal.', 'showStatusButton': false};

                    case '200.3':
                        return {'text': 'Das hat nicht geklappt. Beauftragen Sie die Rufnummern-Mitnahme bitte nochmal.', 'showStatusButton': false};

                    case '401.1':
                        return {'text': 'Sie sind nicht eingeloggt. Versuchen Sie es bitte nochmal', 'showStatusButton': false};

                    case '400.9':
                        return {'text': 'Das hat nicht geklappt. Beauftragen Sie die Rufnummern-Mitnahme bitte nochmal.', 'showStatusButton': false};

                    default:
                        return {'text': 'Ups! Die Technik hakt grad. Sorry, unser Fehler. Deine Rufnummern-Mitnahme können wir im Moment nicht bearbeiten. Bitte versuch\'s später nochmal. Danke für Dein Verständnis!', 'showStatusButton': false};
                    }
                }
            };

            /**
             * just an alias to access from view
             */
            vm.logout = function() {
                $rootScope.loading = true;
                mnpNbaProvider.logout();
            };

            function checkBasket(response) {
                mnpFormProvider.portingRequestCheckoutGet(vm.config.apiURLs.CHECKOUT).then(createFormObject, throwError);
            };

            function createFormObject(response) {
                if (true === response.data.basket.VALID) {
                    vm.formUsable = true;
                }
                window.portingForm = response.data;
            };

            function continueFlow(response) {
                mnpFormProvider.portingRequestBasketGet(vm.config.apiURLs.BASKET).then(checkBasket, throwError);
            };

            vm.throwError = function (response) {
                throwError(response);
            };

            function throwError(response) {
                $rootScope.loading = false;
                trackingSrv.trackError(response.data.responseCode, trackingSrv.E_TYPE_TECHNICAL, response.data.description, $state.current.url);
            };
        };

    }
})();
